import React from 'react';

import { Box } from 'UIKit';

import styles from './cardsArea.module.scss';

const CardSkeleton = (props: React.ComponentProps<typeof Box>) => {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Box className={styles.cardSkeleton} {...props} />;
};

export { CardSkeleton };
